<template>
  <div id="app">
    <navbar/>
    <router-view />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      show: true
    }
  },
  watch: {
    '$route' (to, from) {
      // // ルートの変更の検知...
      // this.show = false
      // this.$refs.today.findPanelForecast()
      // this.$refs.tommorow.findPanelForecast()

    }
  }

}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.panel{
  background: rgba(255,255,255,0.9)
}

.compass {
    position: relative;
    opacity: 0.7
} 
.compass-component {
  position: absolute;
}

.arrow {
  animation: r1 .7s;
}
@keyframes r1 {
  0%   { transform: rotate(90deg); }
}

.updated{
  position: relative;
  left:20px;
  top: 94px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue